module.exports = __webpack_public_path__ + "static/index/img/baikal-701.cf905cf8.jpg";